export default "__VITE_ASSET__Dp0QN6zd__"